import { SVGInterface } from "../../interface";

const CaretDuoRight = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M9.11523 20.23L10.8852 22L20.8852 12L10.8852 2L9.11523 3.77L17.3452 12L9.11523 20.23Z"
      fill={color || "#0E171F"}
    />
    <path
      d="M3.11523 20.23L4.88523 22L14.8852 12L4.88523 2L3.11523 3.77L11.3452 12L3.11523 20.23Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default CaretDuoRight;
